// TAB COLLECTION GRID

const indicatorPro = document.querySelector(".nav-indicator-pro");
const itemsPro = document.querySelectorAll(".nav-item-pro");

function handleIndicatorPro(el) {
  itemsPro.forEach((item) => {
    item.classList.remove("is-active");
    item.removeAttribute("style");
  });

  indicatorPro.style.width = `${el.offsetWidth}px`;
  indicatorPro.style.left = `${el.offsetLeft}px`;
  indicatorPro.style.backgroundColor = el.getAttribute("active-color");

  el.classList.add("is-active");
  el.style.color = el.getAttribute("active-color");
}

itemsPro.forEach((item, index) => {
  item.addEventListener("click", (e) => {
    handleIndicatorPro(e.target);
  });
  item.classList.contains("is-active") && handleIndicatorPro(item);
});

$(".nav-item-pro").click(function (e) {
  e.preventDefault();
  var df = $(this).attr("data-for");
  $(".tab-collection-grid").hide();
  $(".tab-collection-grid." + df).show();

  $(".tab-collection-grid." + df)
    .find(".pro-collection-gallery")
    .each(function () {
      if ($(this).hasClass("slick-initialized")) {
        $(this).slick("unslick");
      }

      $(this).slick({
        dots: true,
        infinite: true,
        speed: 200,
        cssEase: "linear",
        arrows: false,
      });
    });
});
// END TAB COLLECTION GRID


$("#stickySelect1").on("change", function () {
  // Get the selected value
  var selectedValue = $(this).val();

  $("#stickySelect2").val(selectedValue);
  var selectedValueArr = selectedValue.split(" / ");

  if (selectedValueArr[0] == undefined) {
  } else {
    $('select[data-option="option1"]').val(selectedValueArr[0]);
  }
  if (selectedValueArr[1] == undefined) {
  } else {
    $('select[data-option="option2"]').val(selectedValueArr[1]);
  }

  $('[name="option-0"]').each(function (e) {
    if ($(this).val() == selectedValueArr[0]) {
      console.log("dddd");
      $(this).prop("checked", "checked");
      $(this).trigger("change");
    }
  });
  setTimeout(function () {
    $('.single-option-selector [data-option="option1"]').trigger("change");
  }, 1000);
});

$(document).on("change", 'select[data-option="option1"]', function () {
  // Get the selected value
  var sele1val = $('select[data-option="option1"] option:selected').val();
  var sele2val = $('select[data-option="option2"] option:selected').val();
  var newselval = "";
  if (sele1val == undefined) {
  } else {
    newselval = sele1val;
  }
  if (sele2val == undefined) {
  } else {
    newselval += " / " + sele2val;
  }
  //var selectedValue = $(this).val();

  $("#stickySelect1").val(newselval);
  $("#stickySelect2").val(newselval);
  setTimeout(function(){
    newselval=newselval.replace(/[\s\W]+/g, '-');
    var newsizeval = newselval.replace(/[\s\W]+/g, '').toLowerCase();
    var variantID = jQuery('.swatch_options .swatch-element[data-value="'+newselval+'"]').attr('data-id');
    if(variantID!=undefined){
      jQuery('#bundle__product_1').val(variantID);
       if($('#bundle__product_2').val()!=""){
        var productId = jQuery('#product_selected_color_2').val();
        var selectedVariantId = jQuery('#'+productId+'__'+newsizeval).val();

         if(selectedVariantId==undefined){
          selectedVariantId='';
          jQuery('.product-select-color-close.close-csv').trigger('click');
        }
        $('#bundle__product_2').val(selectedVariantId);
        $('.product-select-all-color-card').show();
        // $('.'+selValLower+'_not_ava').hide();
        // hideNotVariantExist(selValLower);
        jQuery('.product_select_list').each(function(){
          var totalLength=jQuery(this).find('.product_bundle_two_pack[style="display: none;"]').length;
          if(totalLength>0){
            var bundleCount = jQuery(this).find('.product_bundle_two_pack').last().attr("data-pcount");
            if(bundleCount==totalLength){
              jQuery(this).hide();
            }else{
              if(jQuery('.product_bundle_suit').length==0){
                jQuery(this).show();
              }
            }
          }
        });
      }
    }
  },500);
});

$(document).on("change", '[name="option-0"]', function () {
  var sele1val = $('select[data-option="option1"] option:selected').val();
  var sele2val = $('select[data-option="option2"] option:selected').val();
  var newselval = "";
  if (sele1val == undefined) {
  } else {
    newselval = sele1val;
  }
  if (sele2val == undefined) {
  } else {
    newselval += " / " + sele2val;
  }
  //var selectedValue = $(this).val();

  $("#stickySelect1").val(newselval);
  $("#stickySelect2").val(newselval);
});

$("#stickySelect2").on("change", function () {
  // Get the selected value
  var selectedValue = $(this).val();

  $("#stickySelect1").val(selectedValue);
  var selectedValueArr = selectedValue.split(" / ");
  if (selectedValueArr[0] == undefined) {
  } else {
    $('select[data-option="option1"]').val(selectedValueArr[0]);
  }
  if (selectedValueArr[1] == undefined) {
  } else {
    $('select[data-option="option2"]').val(selectedValueArr[1]);
  }

  $('[name="option-0"]').each(function (e) {
    if ($(this).val() == selectedValueArr[0]) {
      console.log("dddd");
      $(this).prop("checked", "checked");
      $(this).trigger("change");
    }
  });
  setTimeout(function () {
    $('.single-option-selector [data-option="option1"]').trigger("change");
  }, 1000);
});

$(".atc_sticky_addbtn_link").click(function (e) {
  $(".purchase-details__buttons").find('[name="add"]').trigger("click");
});

// $(document).ready(function () {
//   setTimeout(function () {
//     var reviewHeml = $(".atc_sticky_box1")
//       .find(".atc_sticky_rating")
//       .find(".jdgm-prev-badge__text")
//       .html();
//     var newreviewstr = reviewHeml;
//     if(reviewHeml != ''){
//       var newreviewstr = reviewHeml.replace(" reviews", "");
//     }
//     $(".atc_sticky_box1")
//       .find(".atc_sticky_rating")
//       .find(".jdgm-prev-badge__text")
//       .html("(" + newreviewstr + ")");
//   }, 2500);
// });

$('[name="option-0"]').on("click", function () {
  if ($(this).attr("data-lowstock") != "") {
    $(".low_stock_box").show();
    $(".Low_stock_number").html($(this).attr("data-lowstock"));
  } else {
    $(".low_stock_box").hide();
  }
});

$(document).ready(function () {
  var getWidth = $(
    ".product_gallery_style_5 .product_gallery_nav"
  ).innerWidth();
  jQuery(
    ".product_gallery_style_5 .product_gallery .product-gallery__image"
  ).each(function () {
    jQuery(this).css("height", getWidth);
  });
});
$(window).resize(function () {
  var getWidth = $(
    ".product_gallery_style_5 .product_gallery_nav"
  ).innerWidth();
  jQuery(
    ".product_gallery_style_5 .product_gallery .product-gallery__image"
  ).each(function () {
    jQuery(this).css("height", getWidth);
  });
});

// sticky filter buttons
/*
var headerHeight = $("#header").height();
var buttonHeight =(Math.round($(".custom-sort-filter").offset().top) - Math.round(headerHeight));
$(window).scroll(function () {
  var topHeight = $(window).scrollTop();
  if (topHeight > buttonHeight) {
    $("body").addClass("sticky-button");
    $(".custom-sort-filter").css('top',Math.round(headerHeight));
  } else {
    $("body").removeClass("sticky-button");
    $(".custom-sort-filter").css('top',0);
  }
});
*/


var headerHeight = $("#header").height();
var aboveColHeight = $('.shopify-section.collection-banner--main').height();
if (typeof aboveColHeight === "undefined") {
  aboveColHeight = 0;
  var aboveColHeight = $('.collection-header--vv').height();
}
else if(isNaN(aboveColHeight)) {
  aboveColHeight = 0
}
var colFoldHeight = $('.collection-fold-v3').outerHeight() + 19;
if (typeof colFoldHeight === "undefined") {
  colFoldHeight = 0;
}
else if(isNaN(colFoldHeight)) {
  colFoldHeight = 0
}
var buttonHeight = Math.round(aboveColHeight) + Math.round(colFoldHeight);
$(window).scroll(function () {
  var topHeight = $(window).scrollTop();
  //var bcfHeader = $(".bfcm-product-exclusive-offer").height() + 23;
  var bcfHeader = $("#header").height();
  if (typeof bcfHeader === "undefined") {
    bcfHeader = 0
  }
  else if(isNaN(bcfHeader)) {
    bcfHeader = 0
  }
  if (topHeight > buttonHeight) {
    $("body").addClass("sticky-button");
    //$(".custom-sort-filter").css('top',(Math.round(headerHeight) + Math.round(bcfHeader)) + 7);
    $(".custom-sort-filter").css('top',(Math.round(headerHeight)));
  } else {
    $("body").removeClass("sticky-button");
    $(".custom-sort-filter").css('top',0);
  }
});

// $(document).on("change", '.bundle_product select[data-option="option1"]', function () {
//   var selVal = $(this).val();
//   $('.bundle_product select[data-option="option2"]').val(selVal);
//   $('.bundle_product select[data-option="option2"]').trigger("change");
// });

// $(document).on("change", '.bundle_product select[data-option="option2"]', function () {
//   var selVal = $(this).val();
//   $('.bundle_product select[data-option="option1"]').val(selVal);
//   $('.bundle_product select[data-option="option1"]').trigger("change");
// });

// BUNDLE SELECTOR


jQuery(document).ready(function(){
  if(jQuery('.product-bundle-block').hasClass('product_bundle_trousers') || jQuery('.product-bundle-block').hasClass('product_bundle_suit')){
    $(".bundle_variant_label").trigger('click');
  }
});

/* Shirt bundle code start */
$(".bundle_variant_label").click(function() {
  $(".bundle_variant_label").removeClass('is-active');
  $(this).addClass('is-active');
  $('.product-bundle-color').addClass('is-active');
  var limitNumber = $(this).attr('data-limit');
  if(limitNumber == 1){
    $('.single_price').show();
    //$('.4_shirt_149').hide();
    $('.4_shirt_160').hide();
    $('.bedge-price').hide();
    $('#bundle_variant_title').html('Single');
    $('.price-ui-bundle').hide();
    $('.price-ui-normal').show();
    $('.product_color_selection').removeClass('has_bundle');
  }
  else{
    $('.bedge-price').show();
    $('.single_price').hide();
    //$('.4_shirt_149').show();
    $('.4_shirt_160').show();
    $('#bundle_variant_title').html('4-Pack');
    $('.price-ui-bundle').show();
    $('.price-ui-normal').hide();
    $('.product_color_selection').addClass('has_bundle');
  }
  var defaultSockImag = 'https://cdn.shopify.com/s/files/1/0269/6727/7651/files/dummy-socks.png?v=1713935564';
  $('#bundle__product_2').val('');
  $('#bundle__product_3').val('');
  $('#bundle__product_4').val('');
  $('.select_color_2').find('.close-cvs').hide();
  $('.select_color_2').find('.cvs-select--color').show();
  $('.select_color_2').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);

  $('.select_color_3').find('.close-cvs').hide();
  $('.select_color_3').find('.cvs-select--color').show();
  $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
  $('.select_color_4').find('.close-cvs').hide();
  $('.select_color_4').find('.cvs-select--color').show();
  $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
  for(var t=2;t<=4;t++){
      jQuery('[for="select_color_'+t+'"]').find('.label_active_content').hide();
      jQuery('[for="select_color_'+t+'"]').find('.label_draft_content').show();
  }
  var colorDefault = jQuery('.color-box-wrapper.color-active').text();
  jQuery('#bundle__product_1').attr('data-color',colorDefault);
  var defaultVariantId = jQuery('#variant_default_product').val();
  jQuery('#bundle__product_1').val(defaultVariantId);
  var dataImg = jQuery('#img_default').val();

  $('.select_color_label').addClass('selected-variant');
  jQuery('[data-id="select_color_1"]').find('.label_active_content').find('img').attr('src',dataImg);

  jQuery('[data-id="select_color_1"]').find('.label_draft_content').hide();
  jQuery('[data-id="select_color_1"]').find('.label_active_content').show();
  if(limitNumber!=1){
      jQuery('.product_remove_one').show();
      $('.ajax-submit').addClass('custom-pack-bundle');
      //jQuery('.product-block--color-swatch').hide();
      //jQuery('.product-block--color-swatch').addClass('pbcs-hide');
      $('.product-bundle-color').show();
      //$('.product_color_selection').addClass('hide-color-default');
      var tempStr = '';
      $('.select_color_main').hide();
      for(var i=2; i<=limitNumber; i++){
        $('.select_color_'+i).show();
      }

      if(limitNumber == 1){
        $('#bundle__product_2').val('');
        $('#bundle__product_3').val('');
        $('#bundle__product_4').val('');
        $('.select_color_2').find('.close-cvs').hide();
        $('.select_color_2').find('.cvs-select--color').show();
        $('.select_color_2').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_3').find('.close-cvs').hide();
        $('.select_color_3').find('.cvs-select--color').show();
        $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_4').find('.close-cvs').hide();
        $('.select_color_4').find('.cvs-select--color').show();
        $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
      }
      if(limitNumber == 2){
        $('#bundle__product_3').val('');
        $('#bundle__product_4').val('');
        $('.select_color_3').find('.close-cvs').hide();
        $('.select_color_3').find('.cvs-select--color').show();
        $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_4').find('.close-cvs').hide();
        $('.select_color_4').find('.cvs-select--color').show();
        $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
      }
      //$('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
  }/*else if($('.product-bundle-block').hasClass('product-bundle-block_v2')){
      $('.ajax-submit').addClass('custom-pack-bundle');
      $('.product-bundle-color').show();
      $('.product_all_selectbox').hide();
      jQuery('.product_remove_one').hide();
      $('.select_color_main').hide();
      $('.select_color_1').show();
      $('#bundle__product_2').val('');
      $('#bundle__product_3').val('');
      $('#bundle__product_4').val('');
  }*/
  else{
    $('.product-bundle-color').hide();
    //jQuery('.product-block--color-swatch').show();
    //jQuery('.product-block--color-swatch').removeClass('pbcs-hide');
    //$('.product_color_selection').removeClass('hide-color-default');
  }
  selectedColor();
});
/* Shirt bundle code end */

/*var singlePackClearInt=setInterval(function(){
  if($('.product-bundle-block').hasClass('product-bundle-block_v2')){
    packTriggerClick(singlePackClearInt);
  }
},1000);

function packTriggerClick(interval){
  $(".bundle_variant_label").eq(0).attr('data-limit','1');
  $(".bundle_variant_label").eq(0).addClass('is-active');
  $(".bundle_variant_label").eq(0).trigger("click");
  clearInterval(interval);
}*/

jQuery(window).bind('load',function(){
  if(jQuery('.color-box-wrapper.color-active').length!=0){
    var colorGet = jQuery('.color-box-wrapper.color-active').find('.color_name_tooltip').text();
    colorGet=capitalizeFLetter(colorGet);
    colorGet = jQuery.trim(colorGet);
    jQuery('.bundle_selected_color').eq(0).attr('data-color',colorGet);
    selectedColor();
  }
});
function capitalizeFLetter(string) {
  if(string!=""){
    return (string[0].toUpperCase() + string.slice(1));
  }
}

/* Trouser bundle code start */
$(document).on('click', '.select_color_label', function(e) {
  e.stopPropagation();
  if(jQuery(this).hasClass('trouser_select_label') == false){
    var dataId = $(this).attr('data-id');
    var dataSelidId= $(this).attr('data-selid');
    var packActive = $('.bundle_variant_label.is-active').data('limit');
    if(jQuery('.product_bundle_trousers').length!=0 || jQuery('.product_bundle_suit').length!=0){
      packActive=4;
    }
    if(packActive==4){
      jQuery('.product_remove_one').show();
      $('.select_color_label').removeClass('active');
      $('.select_color_label').removeClass('selected-variant');
      $(this).addClass('active');
      $('#'+dataId).prop('checked','checked');
      var radioId = $('.select_color_label.active').prev('[name="select-color"]').attr('id');
      if(radioId!=undefined){
         removeCheckBox(radioId);
      }else{
        $('.select_color_label.active').prev('[name="select-color"]').prop('checked','checked');
      }

      //$('.product-select-all-color').show();
      var activePrev=jQuery('.active_pack').val();
      if(activePrev!=dataId){
        $('.product_all_selectbox').show();
      }else{
        $('.product_all_selectbox').toggle();
      }
      jQuery('.active_pack').val(dataId);
      $('.product-select-all-color-card').attr('data-selid', $(this).attr('data-selid'));
    }else{
      jQuery('.product_remove_one').hide();
    }
  }
});
/* Trouser bundle code end */

function removeCheckBox(radioId) {
  jQuery('.select-color').each(function() {
    if (jQuery(this).attr('id') != radioId) {
      jQuery(this).removeAttr('checked');
    } else {
      if (jQuery('#' + radioId).prop('checked')) {
        jQuery('#' + radioId).removeAttr('checked');
      } else {
        jQuery('#' + radioId).prop('checked', 'checked');
      }
    }
  });
}

//trouser and suit custom bundle start code here

$(document).on('click','.product_bundle_two_pack.product-select-all-color-card',function() {
    var swatchSize = '<div class="swatch_options swatch_options_custom"><div class="swatch is-flex is-flex-wrap " data-option-index="0"> <div class="option_title_custom"><strong>FREE</strong> Trousers Size</div>';
    var productId = jQuery(this).attr('data-pid');
    var dataSelidId = $(this).attr('data-selid');
    var packActive = 4;
    jQuery('.selected-productsize').html('');
    if(packActive==4){
      $('.ajax-submit').addClass('custom-pack-bundle');
      jQuery('.product_remove_one').show();
      var checkout=0;
      var defaultVariantID = 0;
      var flagcheck=0;
      var defaultVariantData = [];
      jQuery('.swatch_options .swatch-element').each(function(){
          var valueDefault = jQuery(this).attr('value').replace(/\W+/g, '');
          defaultVariantData.push(valueDefault);
      });
      jQuery(this).find('.variant_class').each(function(e){
        var size = jQuery(this).attr('variant-size').toUpperCase();
        var sizeVal  = jQuery(this).attr('option-val');
        var availSize = jQuery(this).attr('data-available');
        var variantId = jQuery(this).val();
        var checkstr='';
        if(checkout==0){
          checkstr="checked";
          defaultVariantID = variantId;
        }
        var newsize = size.replace(/\W+/g, '');
        if(defaultVariantData.includes(newsize)){
          flagcheck++;
        }
        var disabledSize='';
        if(availSize==false){
          disabledSize='<img class="crossed-out" src="//tailoredathlete.co.uk/cdn/shop/t/130/assets/soldout.png?v=44413085747100446851723444230" aria-label="sold out" alt="sold out">';
        }
        swatchSize+='<div tabindex="0" value="'+size+'" data-value="'+size+'" data-pid="'+productId+'" data-id="'+variantId+'" class="swatch-element bundle-swatch-custom '+checkstr+'"> <label class="size-variant" for="swatch-'+size+variantId+'__main">';
        swatchSize+=sizeVal+disabledSize+'</div>';
        checkout++;
      });
      swatchSize+= '</div></div>';
      var dataImg = $(this).attr('data-img');
      var dataProductId = defaultVariantID;
      var dataColor = $(this).attr('data-color');
      $('#bundle__product_'+dataSelidId).val(dataProductId);
      $('#product_selected_color_'+dataSelidId).val(productId);
      $('#bundle__product_'+dataSelidId).attr("data-color",dataColor);
      if(flagcheck==0){
        jQuery('.selected-productsize').html(swatchSize);
        jQuery('.custom-bundle-trousers').find('.option_title').text('Trouser 1 Size');
      }else{
        var selectedDefault = jQuery('.swatch_options [name="option-0"]:checked').val();
        selectedDefault = selectedDefault.replace(/[_\W]+/g, "").toLowerCase();
        var selectedVariant = jQuery('#'+productId+'__'+selectedDefault).val();
        if(selectedVariant!=undefined){
          $('#bundle__product_2').val(selectedVariant);
        }
        jQuery('.custom-bundle-trousers').find('.option_title').text('Size');
      }
      $('.select_color_label').addClass('selected-variant');
      $('.select_color_label.active').find('.label_active_content').find('img').attr('src',dataImg);
      $('.select_color_label.active').find('.label_draft_content').hide();
      $('.select_color_label.active').find('.label_active_content').show();
      $('.select_color_label.active').find('.product-select-color-close').show();
      $('.select_color_label.active').addClass('fill-product');
      $('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
      selectedColor();
    }else{
      jQuery('.product_remove_one').hide();
    }
});


$(document).on('click','.product-select-all-color-card',function() {
  var productId = jQuery(this).attr('data-pid');
  var dataSelidId = $(this).attr('data-selid');
  var packActive = $('.bundle_variant_label.is-active').data('limit');
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(packActive==4){
      jQuery('.product_remove_one').show();
      var selectSize = jQuery('.custom-option').find(':selected').attr('data-value').toLowerCase();
      var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
      var dataImg = $(this).attr('data-img');
      var dataProductId = selectedVariantId;
      var dataColor = $(this).attr('data-color');
      //alert(productId+"==="+selectSize+"==="+selectedVariantId+"==="+dataImg+"==="+dataProductId+"==="+dataSelidId+"==="+dataColor)
      $('#bundle__product_'+dataSelidId).val(dataProductId);
      $('#product_selected_color_'+dataSelidId).val(productId);
      $('#bundle__product_'+dataSelidId).attr("data-color",dataColor);
      $('.select_color_label').addClass('selected-variant');
      $('.select_color_label.active').find('.label_active_content').find('img').attr('src',dataImg);
      $('.select_color_label.active').find('.label_draft_content').hide();
      $('.select_color_label.active').find('.label_active_content').show();
      $('.select_color_label.active').find('.product-select-color-close').show();
      $('.select_color_label.active').addClass('fill-product');
      $('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
      selectedColor();
    }
    else{
      jQuery('.product_remove_one').hide();
    }
  }
});

jQuery(document).on("click",".bundle-swatch-custom",function(){
  var vId = jQuery(this).attr('data-id');
  jQuery('.bundle-swatch-custom').removeClass("checked");
  jQuery(this).addClass("checked");
  jQuery('#bundle__product_2').val(vId);
});


jQuery('.select_color_label').click(function(){
  if(jQuery(this).hasClass('trouser_select_label')==false){
    jQuery('.product-select-all-color-card').show();
    var selVal = jQuery('.swatch_options [name="option-0"]:checked').val().replace(/[_\W]+/g, "");
    var selValLower = selVal.toLowerCase();
    $('.product-select-all-color-card').show();
    $('.'+selValLower+'_not_ava').hide();
    hideNotVariantExist(selValLower);
    jQuery('.product_select_list').each(function(){
      var totalLength=jQuery(this).find('.product_bundle_two_pack[style="display: none;"]').length;
      if(totalLength>0){
        var bundleCount = jQuery(this).find('.product_bundle_two_pack').last().attr("data-pcount");
        if(bundleCount==totalLength){
          jQuery(this).hide();
        }else{
          if(jQuery('.product_bundle_suit').length==0){
            jQuery(this).show();
          }
        }
      }
    });
  }
});
function hideNotVariantExist(selValLower){
  jQuery('.product_bundle_two_pack.product-select-all-color-card').each(function(){
    if(jQuery(this).hasClass('exist-variant')){
      if(jQuery(this).hasClass(selValLower+'_size')==false){
        jQuery(this).hide();
      }
    }
  });
}


function selectedColor(){
  var colorString='';
  var colorArr=[];
  jQuery('.bundle_selected_color').each(function(){
    if(jQuery(this).val()!=""){
      //if(jQuery.inArray(jQuery(this).attr('data-color'), colorArr) == -1){
        var colorGet = jQuery(this).attr('data-color');
        colorGet = capitalizeFLetter(colorGet);
        colorString+=colorGet+', ';
        colorArr.push(jQuery(this).attr('data-color'));
      //}
    }
  });
  if(colorString!=""){
    //if(colorArr.length>1){
      colorString = colorString.replace(/,(\s+)?$/, '');
      jQuery('.product-bundle-color-heading').show();
      jQuery('.product-bundle-color-heading').find('.color-selected').text(colorString);
    /*}else{
      var colorDefault = jQuery('.color-box-wrapper.color-active').text();
      jQuery('.product-bundle-color-heading').show();
      jQuery('.product-bundle-color-heading').find('.color-selected').text(colorDefault);
    }*/
  }
}

$('.close-csv').on('click',function(){
  var dataSelidId = $(this).attr('data-selid');
  $('#bundle__product_'+dataSelidId).val('');
  $('#product_selected_color_'+dataSelidId).val('');
  $('.select_color_label').removeClass('active');
  $(this).parent().parent().removeClass('fill-product');
  $('.select_color_label').removeClass('selected-variant');

  $(this).parent().hide();
  $('.label_draft_content').show();
  jQuery('.selected-productsize').html('');
  jQuery('.custom-bundle-trousers').find('.option_title').text('Size');
  selectedColor();
  //$(this).parent('.select_color_label').find('img').attr('src',variant_default_img);
});

/*$(document).on('click','.product-select-color-close',function(e){
  $('.label_draft_content').show();
  $('.label_active_content').hide();
});*/

jQuery('.swatch_options .swatch-element').click(function(){
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(jQuery('.bundle_variant_label.is-active').length!=0){
      var selectedSize = jQuery(this).attr('data-value').toLowerCase();
      sizeWiseSelected(selectedSize);
    }
  }else if(jQuery('.bundle-swatch-custom').length!=0){
      if($('#bundle__product_1').val()!=""){
        var selectedVariantId = jQuery(this).attr('data-id');
        $('#bundle__product_1').val(selectedVariantId);
      }
  }else{
      var selVal = jQuery(this).attr('data-value');
      var selValLower = selVal.toLowerCase();
      selValLower=selValLower.replace('-',"");
      $('.product-select-all-color-card').show();
      $('.'+selValLower+'_not_ava').hide();
      $('.'+selValLower+'size').hide();
      var selectedSize = jQuery(this).attr('data-value').toLowerCase();
      selectedSize=selectedSize.replace('-',"");
      sizeWiseSelectedTwo(selectedSize);
  }
});
jQuery(document).ready(function(){
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(jQuery('.bundle_variant_label.is-active').length!=0){
      var selectedSize = jQuery('div.select').find('.custom-option option:selected').attr('data-value');
      sizeWiseSelected(selectedSize);
    }
  }
});
function sizeWiseSelected(selectSize){
  var limitPack = jQuery('.bundle_variant_label.is-active').attr('data-limit');
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
      $('#bundle__product_'+p).val(selectedVariantId);
    }
  }
  jQuery('.selected-swatchval').text(selectSize);
}

function sizeWiseSelectedTwo(selectSize){
  var limitPack =2;
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      if(productId!=undefined){
        var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
        if(selectedVariantId==undefined){
          selectedVariantId='';
          jQuery('.product-select-color-close.close-csv').trigger('click');
        }
        $('#bundle__product_'+p).val(selectedVariantId);
      }
    }
  }
}
var legthArr=[];
var legthArr1=[];

jQuery(window).bind('load',function(){
    setInterval(function(){
      if(jQuery('.bundle_variant_label').length!=0){
        jQuery('.bundle_variant_label').show();
      }
    },1500);
    jQuery('.product-info__title').each(function() {
        var height = jQuery(this).height();
        legthArr1.push(height);
    });
    var maxValue = Math.max.apply(Math,legthArr1);
    maxValue = Math.round(maxValue);
    jQuery('.product-info__title').each(function() {
        jQuery(this).css('height',maxValue);
        jQuery(this).css('display','block');
    });

    jQuery('.cpc-color-swatch').each(function() {
        var height = jQuery(this).height();
        legthArr.push(height);
    });
    var maxValue1 = Math.max.apply(Math,legthArr);
    maxValue1 = Math.round(maxValue1);
    jQuery('.cpc-color-swatch').each(function() {
        jQuery(this).css('height',maxValue1);
    });

});

/* bundle page js start */
jQuery('.bb_product__imgbox').click(function(){
  var popupPid = $(this).attr('data-pid');
  var productUrl = $(this).attr('data-url');

  //$('.popup__loader').addClass('loader__active');
  $('.popup_loader__box').addClass('loader__active');
  $('.bundle_builder_popup').attr('id', 'bundle_builder_popup_'+popupPid);
  $('.bundle_builder_popup').attr('data-pid', popupPid);
  jQuery.ajax({
    url: productUrl,
    type: 'GET',
    success: function(response) {
      var newContentHTML = response['ajax-product-popup-bundle'];
      // Create a temporary container to parse the new HTML content

      $('.bundle_builder_popupbox').html('');
      $('.bundle_builder_popupbox').append(newContentHTML);

      $('body').addClass('bundle_popup_open');
      $('#bundle_builder_popup_'+popupPid).show();
      //$('.popup__loader').removeClass('loader__active');
      $('.popup_loader__box').removeClass('loader__active');
    },
    error: function(xhr, status, error) {
      console.error('AJAX Error:');
    }
  });

  //$('#bundle_builder_popup_'+popupPid).addClass("open-popup");

});

jQuery(document).on('click','.bundle_popup_swatch',function(){
  var popupPid = $(this).attr('data-pid');
  $('body').addClass('bundle_popup_open');
  $('.bundle_builder_popup').attr('id', 'bundle_builder_popup_'+popupPid);
  $('.bundle_builder_popup').attr('data-pid', popupPid);
  $('.bb_popup_details').hide();
  $('.bb_popup_details__'+popupPid).show();
  $('.bb_popup_details').removeClass("open-popup");
  $('.bb_popup_details__'+popupPid).addClass("open-popup");
  // $('.bundle_builder_popup').hide();
  // $('.bundle_builder_popup').removeClass("open-popup");
  // $('#bundle_builder_popup_'+popupPid).addClass("open-popup");
  // $('#bundle_builder_popup_'+popupPid).show();
});

jQuery(document).on('click','.bb_popup_closebtn',function(){
  $('body').removeClass('bundle_popup_open');
  $('.bundle_builder_popupbox').html('');
  $('.bundle_builder_popup').hide();
  jQuery('.selected-productsize').html('');
});

$(document).ready(function() {
  $('.bb_nav_list').on('click', function() {
    var target = $(this).data('target');
    var targetOffset = $('#' + target).offset().top;

    $('html, body').animate({
        scrollTop: targetOffset
    }, 500); // Adjust the duration as needed
  });
});
/* bundle page js end */

let bundleProductArr = [];
//deleteCookie('zipcode_set');
jQuery(document).on('click','.open-popup .bb_popup_atcbtn',function(e){
    e.preventDefault();
    e.stopPropagation();
    var productId = jQuery('.bb_popup_details.open-popup').data('pid');
    var variantId = jQuery('.bb_popup_details.open-popup').find('[name="radio-'+productId+'"]:checked').attr('data-id');

    var ptitle = jQuery('.bb_popup_details.open-popup').find('.bb_popup_title').text();
    var variant_qnt=parseInt(jQuery('.bb_popup_details.open-popup').find('.bundle_qunatity').val());
    var pimage = jQuery('.bb_popup_details.open-popup .bb_popup_img').find('img').attr('src');
    if (!variantExists(bundleProductArr, variantId)) {
        bundleProductArr.push({
            product_id: productId,
            variant_id: variantId,
            quantity: variant_qnt,
            title: ptitle,
            product_image: pimage
        });
    } else {
        for (var r = 0; r < bundleProductArr.length; r++) {
            if (bundleProductArr[r] !== undefined && bundleProductArr[r].variant_id === variantId) {
                bundleProductArr[r].quantity = parseInt(bundleProductArr[r].quantity) + parseInt(variant_qnt);
                break; // Exit loop after updating the quantity
            }
        }
    }
    addBundlelist();
});

function addBundlelist(){
  if(bundleProductArr.length>0){
      var bundleProductData=bundleProductArr;
      var productBundleData = bundleProductArr;

      let variantCount = 0;
      var bundleCollection = '';
      var showslide = 0;
      var productBoxcounter = 1;
      var productGroup = []; // Array to hold groups of five products
      var productMain=0;
      for (var y = 0; y < productBundleData.length; y++) {
          var imagesrc = '';
          if (productBundleData[y] != undefined) {
              var productImage = productBundleData[y].product_image;
              var productTitle = productBundleData[y].title;
              var productId = productBundleData[y].product_id;
              var variantId = productBundleData[y].variant_id;
              var quantity = productBundleData[y].quantity;

              var productHTML = '<div class="bb_checkout_list product-fill-box bundle_add_' + variantId + '">';
              productHTML += '<div class="bb_checklist_full">';
              productHTML += '<img src="' + productImage + '"><div class="bb_check_remove" data-vid="' + variantId + '">';
              productHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">';
              productHTML += '<path d="M6 1.36194V10.6383" stroke="#2E2520" stroke-width="1.5" stroke-linecap="round"/></path>';
              productHTML += '<path d="M10.5 5.98022H1.5" stroke="#2E2520" stroke-width="1.5" stroke-linecap="round"/></path>';
              productHTML += '</svg></div>';
              if (parseInt(quantity) > 1) {
                  productHTML += '<div class="bb_check_productquanti"><span>' + quantity + '</span></div>';
              }
              productHTML += '</div></div>';
              productGroup.push(productHTML);
              showslide++;
              imagesrc=productImage;
              productMain++;
              variantCount+=quantity;
          }

          // Check if we have collected 5 products
          if (showslide == 5 || y == productBundleData.length - 1) {
              var groupHTML = '<div class="bundle-bunch"' + (showslide==5 ? ' style="display:none;"' : '') + '>';
              groupHTML += productGroup.join('') + '</div>';
              bundleCollection += groupHTML;
              productGroup = []; // Reset for next group
          }
          if(y==4){
             bundleCollection+='<div class="bb_checkout_list bundle_full_box bundle_add_'+variantId+'">';
             bundleCollection+='<div class="image_section"><div class="show_all_qnt"><span class="count-products">'+productMain+'</span></div>';
             bundleCollection+='<div class="bb_checklist_full">';
             bundleCollection+='<img src="'+imagesrc+'"></div></div>';
             bundleCollection+='</div>';
          }
          if (showslide == 5){
            showslide = 0;
          }

          productBoxcounter++;
      }

      // Handle the case where the number of products is less than 5
      if (productBundleData.length > 0 && productBundleData.length < 5) {
          var endloop = (5 - showslide);
          for (var t = 0; t < endloop; t++) {
              bundleCollection += '<div class="bb_checkout_list top"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      } else if (productBundleData.length > 0 && showslide != 0) {
          var endloop = (5 - showslide);
          for (var t = 0; t < endloop; t++) {
              bundleCollection += '<div class="bb_checkout_list top-second"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      } else if (productBundleData.length >= 5 && showslide == 0) {
          for (var w = showslide; w < 5; w++) {
              bundleCollection += '<div class="bb_checkout_list bottom"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      }

      jQuery('.bb_checkout_listbox').html(bundleCollection);
      jQuery('.bb_checkout_btn_list span').text(variantCount);
      if(jQuery('.count-products').length>0){
        jQuery('.count-products').text(productMain);
      }
      var firstitems=6;
      var seconditems=9;
      var thirditems=12;
      var ramainProduct=0;
      var percentage = parseInt(100/thirditems);
      var percentageWidth=0;
      if(firstitems>variantCount){
        ramainProduct = (firstitems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('45%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(seconditems>variantCount){
        ramainProduct = (seconditems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('50%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(thirditems>variantCount){
        ramainProduct = (thirditems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('55%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(variantCount>=thirditems){
        //jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.saveoff').hide();
        jQuery('.saveoff-full').show();
        jQuery('.bb_progress_filled').css('width','100%');
      }
  }else{
    var bundleCollection='';
    for (var t = 1; t <= 5; t++) {
          bundleCollection += '<div class="bb_checkout_list top"><div class="bb_checklist_blank"><span>' +t+ '</span></div></div>';
          productBoxcounter++;
    }
    jQuery('.bb_checkout_listbox').html(bundleCollection);
    jQuery('.bb_checkout_btn_list span').text(0);
    jQuery('.count-products').text(0);
    jQuery('.saveoff').show();
    jQuery('.saveoff-full').hide();
    jQuery('.bb_progress_title .progress-count').text(6);
    jQuery('.bb_progress_filled').css('width','0%');
  }
}

jQuery(document).on("click",".bb_check_remove",function(){
  console.log("remove",jQuery(this).data('vid'));
  var variantId = jQuery(this).data('vid');
  console.log("bundleProductArr",bundleProductArr);
  if(variantId!="" && variantId!=undefined){
    console.log("variantId",variantId);
    jQuery('.bundle_add_'+variantId).remove();
    bundleProductArr = removeVariantId(bundleProductArr, variantId);
    addBundlelist();
  }
});

jQuery(document).on("click",".bundle_full_box",function(){
  jQuery('.bundle-bunch').show();
  jQuery('.image_section').hide();
  if(jQuery('.hide_link_box').length>0){
    jQuery('.hide_link_box').remove();
  }
  if(jQuery('.bb_checkout_list.bottom').length>0){
    jQuery('.bb_checkout_list.bottom').hide();
  }
  jQuery(this).hide();
  jQuery('.top-second').hide();
  var stringHide = '<div class="hide_link_box"><span>Hide items</span></div>';
  jQuery('.bundle-bunch').last().append(stringHide);
});

jQuery(document).on("click",".hide_link_box",function(){
  jQuery('.bundle_full_box').show();
  jQuery('.top-second').show();
  if(jQuery('.bb_checkout_list.bottom').length>0){
    jQuery('.bb_checkout_list.bottom').show();
  }
  if(jQuery('.bundle-bunch').length==1){
    jQuery('.bundle-bunch').hide();
  }else{
    jQuery('.bundle-bunch').hide();
    if(jQuery('.bb_checklist_blank').length!=5){
      jQuery('.bundle-bunch').last().show();
    }
  }
  jQuery('.image_section').show();
  jQuery(this).remove();
});

jQuery(document).on("click",".bb_checkout_btn",function(){
  if(bundleProductArr.length>0){
    jQuery('.check-button-bb').hide();
    jQuery('.upv-loading').show();
    var itemArr=[];
    for(var d=0;d<bundleProductArr.length;d++){
      if(bundleProductArr[d].variant_id!=undefined){
          itemArr.push({
              id: bundleProductArr[d].variant_id,
              quantity: bundleProductArr[d].quantity,
          });
      }
    }
    if(itemArr.length>0){
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {items:itemArr},
        beforeSend() {
          //curbutton.addClass('is-loading');
          //curbutton.attr('disabled', 'disabled').addClass('disabled');
        },
        success(res) {
          window.location="/checkout";
        },
        error(XMLHttpRequest) {

        },
      });
    }
  }
});

function removeVariantId(arr, variantId) {
    var filteredArray = arr.filter(function(item) {
        return parseInt(item.variant_id) !== parseInt(variantId);
    });
    return filteredArray;
}

function variantExists(array, variantId) {
    return array.some(item => item.variant_id === variantId);
}

/*
jQuery(window).bind('load',function(){
    if(jQuery('body').hasClass('index')){
      setTimeout(function(){
        if(getCookie('urgency_value')){
          if(getCookie('urgency_value')!=""){
            jQuery('.urgency_popup').hide();
          }
        }else{
          jQuery('.urgency_popup').show('fast');
        }
      },2000);
    }
});
jQuery(document).on("click",".urgency-close",function(){
  setCookie('urgency_value','1',1);
  jQuery('.urgency_popup').hide();
});
*/

function getCookie(name){
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days){
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function deleteCookie(name){
  setCookie(name, '', -1);
}

/* COLLECTION OFFER POPUP -- START */

$(document).ready(function() {
  var openBtn = $('.cf_box_openbtn');
  var closeBtn = $('.cf_popup_close');

  // Only add event listeners if the elements exist
  if (openBtn.length) {
    openBtn.on('click', function() {
      $('.collection_offer_popup').css('display', 'block');
      $('body').addClass('collection_offer_popup_active');
    });
  }

  if (closeBtn.length) {
    closeBtn.on('click', function() {
      $('.collection_offer_popup').css('display', 'none');
      $('body').removeClass('collection_offer_popup_active');
    });
  }
});
/* COLLECTION OFFER POPUP -- END */

/* CART OFFER POPUP -- START */
jQuery(document).on('click','.cart-ab-openbtn',function(){
  $(".cart_offer_popup").show();
  $(".tos_warning").find('form').addClass("cart-popup-open");
});
jQuery(document).on('click','.cart-popup-close',function(){
  $(".cart_offer_popup").hide();
  $(".tos_warning").find('form').removeClass("cart-popup-open");
});


/* CART OFFER POPUP -- END */

$(document).ready(function() {
    getHeaderHeight();
});
function getHeaderHeight(){
  var classHeaderHeight = jQuery('#header').outerHeight();
  document.documentElement.style.setProperty('--header-height', classHeaderHeight+ 'px');
}
$(window).on('load', function () {
    getHeaderHeight();
});
$(window).on('resize', function () {
    getHeaderHeight();
});


$(document).ready(function() {
    getcartHeight();
});
function getcartHeight(){
  var classcartHeight = jQuery(window).height();
  document.documentElement.style.setProperty('--viewport-height', classcartHeight+ 'px');
}
$(window).on('resize', function () {
    getcartHeight();
});

$(document).on("change",".single-option-selector", function () {
  $('.selected-swatchval').text($(this).val());
});



/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT START *****************************/

jQuery(document).on("click", ".size-button-section .size-buttons", function (e) {
    var headerHeight = jQuery('.shopify-section--header').find('.mobile_nav-fixed--true').height();
    headerHeight = parseInt(headerHeight);
    jQuery('html,body').animate({
        scrollTop: (jQuery('.product-block.product-block--title').offset().top - headerHeight)
    }, 100);
    e.preventDefault();
});

// jQuery('body').addClass('pdp-button-size-v1');
// jQuery('body').addClass('pdp-button-size-v2');

jQuery(window).on("scroll", function () {
    if(jQuery(".purchase-details").find('.add_to_cart').length>0){
      const target = jQuery(".purchase-details").find('.add_to_cart');
      const hideshowSize = jQuery(".size-button-section");
      const windowHeight = jQuery(window).height();
      const scrollTop = jQuery(window).scrollTop();
      const elementOffset = target.offset().top;

      if (jQuery('body').hasClass('pdp-button-size-v1')) {
          if (scrollTop + windowHeight > elementOffset && scrollTop < elementOffset + target.height()) {
              hideshowSize.hide();
          } else {
              hideshowSize.show();
          }
      } else if (jQuery('body').hasClass('pdp-button-size-v2')) {
          if (scrollTop + windowHeight > elementOffset) {
              hideshowSize.hide();
          } else {
              hideshowSize.show();
          }
      }
    }
});



/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT END *******************************/

/*
jQuery(window).bind('load',function(){
  console.log("iiiiiii",jQuery('.boost-product-single').length);
  setTimeout(function(){
  jQuery('.boost-product-single').each(function(){
    console.log("length img",jQuery(this).find('.product_image').find('.slick-slide').length);
    if(jQuery(this).find('.slick-slide').find('img').length==1){
      jQuery('.boost-product-single').addClass('no-slider-display');
    }
  });
  },1000);
});
*/

/*************************** PRODUCT DETAILS PAGE SIZE DROPDOWN CHANGE EVENT START **************************/
if(jQuery('body').hasClass('tem-product')){
  jQuery(document).on('change',".single-option-selector[data-option='option1']",function(){
    var selectedValue = jQuery(this).val();
    jQuery(".single-option-selector[data-option='option2']").val(selectedValue);
    jQuery(".single-option-selector[data-option='option2']").trigger("change");
    jQuery(".single-option-selector[data-option='option3']").val(selectedValue);
    jQuery(".single-option-selector[data-option='option3']").trigger("change");
  });
}
/*************************** PRODUCT DETAILS PAGE SIZE DROPDOWN CHANGE EVENT END **************************/

/************* PRODUCT DETAILS PAGE SIZE [shipphours] timing EST STRAT **************/
function startCountdown() {
    const now = new Date();
    const estOffset = -5 * 60; // EST offset in minutes
    const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
    const estNow = new Date(utcNow + estOffset * 60000);

    let targetTime = new Date(estNow);
    targetTime.setHours(12, 0, 0, 0); // Set to 12:00 PM EST

    if (estNow.getHours() >= 12) {
        // If it's after 12:00 PM EST, set target to tomorrow's 12:00 PM EST
        targetTime.setDate(targetTime.getDate() + 1);
    }

    function updateTimer() {
        const now = new Date();
        const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
        const estNow = new Date(utcNow + estOffset * 60000);

        let timeDiff = targetTime - estNow;
        if (timeDiff <= 0) {
            startCountdown(); // Restart countdown when it reaches 0
            return;
        }

        let hours = Math.floor(timeDiff / 3600000);
        let minutes = Math.floor((timeDiff % 3600000) / 60000);
        let seconds = Math.floor((timeDiff % 60000) / 1000);
        if(jQuery('#countdown').length>0){
          document.getElementById("countdown").textContent =
            `${hours} hours`;
        }
        //${minutes}m ${seconds}s

        setTimeout(updateTimer, 1000);
    }

    updateTimer();
}

document.addEventListener("DOMContentLoaded", startCountdown);

/************* PRODUCT DETAILS PAGE SIZE [shipphours] timing EST END **************/

/************* PRODUCT DETAILS PRODUCT GALLERY ON CONVERT SHOW JS START **************/
/*jQuery(document).ready(function () {
  if(jQuery('.productstate.convert_slider_product').length > 0) {
     var $sliderContainer = jQuery('.productstate.convert_slider_product .product_gallery.js-product-gallery');
     var interId = setInterval(function () {
       if(jQuery('.productstate.convert_slider_product .product_gallery.js-product-gallery').length>0){
          if($sliderContainer.is(':visible')) {
              setTimeout(function () {
                  $sliderContainer.flickity('resize');
              }, 500);
               clearInterval(interId);
         }

       }
     },100);
  }
});*/
jQuery(window).bind('load',function () {
  if(jQuery('.productstate.convert_slider_product').length > 0) {
     var $sliderContainer = jQuery('.productstate.convert_slider_product .product_gallery.js-product-gallery');
     let $thumbSlider = jQuery('.product-gallery--wrp .product_gallery.js-product-gallery');
     // Initialize Flickity for the thumbnail slider
     let thumbFlkty = new Flickity($thumbSlider[0], {
        asNavFor: '.product_gallery.js-product-gallery', // Sync with main gallery
        contain: true,
        pageDots: false,
        wrapAround: true,
        draggable: true
     });
     thumbFlkty.on('change', function (index) {
        $sliderContainer.flickity('selectCell', index);
     });
     var interId = setInterval(function () {
       if(jQuery('.productstate.convert_slider_product .product_gallery.js-product-gallery').length>0){
          if($sliderContainer.is(':visible')) {
              setTimeout(function () {
                  $sliderContainer.flickity('resize');
              }, 500);
               clearInterval(interId);
         }
         if(jQuery(window).width()<1024){
          jQuery(document).on('click touchend','.product_gallery_nav.product-gallery__thumbnails .gallery-cell.product-gallery__thumbnail,.product_gallery.product-gallery__thumbnails .gallery-cell.product-gallery__thumbnail', function () {
              let index = jQuery(this).index(); // Get index of the clicked thumbnail
              if (jQuery(this).hasClass('is-selected')) {
                  $sliderContainer.flickity('selectCell', index);
              }
          });
        }
      }
    },100);
  }
});
/************* PRODUCT DETAILS PRODUCT GALLERY ON CONVERT SHOW JS END **************/

/************************ landing featured product JS START **************************/
jQuery(document).ready(function() {
  jQuery(".fp-accordian > .fp-accordian-heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideUp(200);
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".fp-accordian > .fp-accordian-heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".fp-accordian-content").slideUp(200);
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideDown(200);
    }
  });
});

/************************ landing featured product JS END **************************/

/* limited sale -- START */

//PRODUCT DETAIL PAGE AND OTHER FOR SET DAYS AND HOURS AND MINUTES LIMITED DAYS SET JS START
$(document).ready(function () {
  var timerEl = $('.limited-sale .sale-timer');
  var globalTimerEl = $('.timer-pdp-and-cart-offers');

  if (globalTimerEl.length > 0) {
    var targetTimeStr = globalTimerEl.attr('data-end-time'); // ISO format
    var targetTime = new Date(targetTimeStr).getTime();

    var countdownInterval = setInterval(function () {
      var currentTime = new Date().getTime();
      var timeRemaining = targetTime - currentTime;

      if (timeRemaining <= 0) {
        clearInterval(countdownInterval);
        timerEl.hide(); // Or you can show a message instead
      } else {
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // timerEl.find('.sale-day span').text(days);
        timerEl.find('.sale-hour span').text(hours);
        timerEl.find('.sale-minute span').text(minutes);
        timerEl.find('.sale-second span').text(seconds);
      }
    }, 1000);
  }
});

//PRODUCT DETAIL PAGE AND OTHER FOR SET DAYS AND HOURS AND MINUTES LIMITED DAYS SET JS END

// announcement timer - start

// function startCountdownWithoutDays() {
//   var timerEl = jQuery('.limited-sale-announcement').find('.sale-timer');
//   var hoursToEnd = parseInt(timerEl.attr('data-time'), 10);
//   var minutesToEnd = parseInt(timerEl.find('.sale-time[minute-time]').attr('minute-time'), 10);

//   if (isNaN(hoursToEnd)) hoursToEnd = 0;
//   if (isNaN(minutesToEnd)) minutesToEnd = 0;

//   let saleEndTime = new Date().getTime() + ((hoursToEnd * 60 + minutesToEnd) * 60 * 1000);

//   function updateTimer() {
//     let now = new Date().getTime();
//     let timeLeft = saleEndTime - now;

//     if (timeLeft > 0) {
//       let totalSeconds = Math.floor(timeLeft / 1000);
//       let hours = Math.floor(totalSeconds / 3600);
//       let minutes = Math.floor((totalSeconds % 3600) / 60);
//       let seconds = totalSeconds % 60;

//       let format = (val) => val < 10 ? "0" + val : val;

//       if (timerEl.find(".sale-time").length > 0) {
//         timerEl.find(".sale-hour span").text(format(hours));
//         timerEl.find(".sale-minute span").text(format(minutes));
//         timerEl.find(".sale-second span").text(format(seconds));
//       }
//     } else {
//       timerEl.hide();
//       clearInterval(timer);
//     }
//   }

//   updateTimer();
//   let timer = setInterval(updateTimer, 1000);
// }

// jQuery(document).ready(function () {
//   if (jQuery(".sale-timer").find(".sale-time").length > 0) {
//     startCountdownWithoutDays();
//   }
// });
// announcement timer - end


/* limited sale -- END */

/************************** COLLECTION GRID LAYOUT CHANGE START JS ***********************/
 $(document).on('click','.six-item-btn',function(){
  $('.custom-filter-grids button').removeClass('active')
  $(this).addClass('active')
  $('.grid-layout-box').removeClass('grid-item-four grid-item-one');
  $('.grid-layout-box').addClass('grid-item-six');
  slickSliderRefresh();
});
$(document).on('click','.four-item-btn',function(){
  $('.custom-filter-grids button').removeClass('active');
  $(this).addClass('active')
  $('.grid-layout-box').removeClass('grid-item-one grid-item-six');
  $('.grid-layout-box').addClass('grid-item-four');
  slickSliderRefresh();
});
$(document).on('click','.one-item-btn',function(){
  $('.custom-filter-grids button').removeClass('active')
  $(this).addClass('active')
  $('.grid-layout-box').removeClass('grid-item-four grid-item-six');
  $('.grid-layout-box').addClass('grid-item-one');
  slickSliderRefresh();
});
function slickSliderRefresh(){
 if($(window).width()<=576){
   $('.slider-image-wrapper').slick('refresh');
 }
}
/************************** COLLECTION GRID LAYOUT CHANGE END JS *************************/

// =======================================================
/* Hero slider || sections/hero-slider.liquid -- START  */

jQuery(document).ready(function() {
  jQuery('.heroslider-slick').slick({
    dots: true,
    autoplay: true,
    infinite: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 19.03125 4.28125 L 8.03125 15.28125 L 7.34375 16 L 8.03125 16.71875 L 19.03125 27.71875 L 20.46875 26.28125 L 10.1875 16 L 20.46875 5.71875 Z"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z"/></svg></button>',
  });
});

/* Hero slider || sections/hero-slider.liquid -- START  */
// =======================================================

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
$(document).ready(function () {
  if(jQuery('.testimonial-section').find('.testimonial-wrap').length>0){
    var sliderInterId = setInterval(function(){
      if(!$('.testimonial-wrap').hasClass('slick-initialized')){
        $('.testimonial-wrap').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [
           {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              dots: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              dots: true,
            },
          },
          ],
        });
        clearInterval(sliderInterId);
        sameHeightTestimonial();
      }
    },100);
  }
});
function sameHeightTestimonial(){
  var legthArr=[];
  if(jQuery('.testimonial-section .testimonial-wrap').find('.slick-slide').length>0){
    jQuery('.testimonial-section .testimonial-wrap').find('.main-inner-review').each(function() {
        var height = jQuery(this).outerHeight();
        legthArr.push(height);
    });
    var maxValue = Math.max.apply(Math,legthArr);
    maxValue = Math.round(maxValue);
    jQuery('.testimonial-section .testimonial-wrap').find('.main-inner-review').each(function() {
        jQuery(this).css('height',maxValue);
    });
  }
}
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS REVIEW JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

$(document).ready(function () {
  if(jQuery('.testimonial-reviews-section').find('.testimonial-review-slider').length>0){
    $('.testimonial-review-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '25px',
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          centerPadding: '35px',
          centerMode: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true,
        },
      },
      ],
    });
  }
});

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS REVIEW JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ PRODUCT REANGE SHOWCASE JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

$(document).ready(function () {
  if(jQuery('.prs_section').find('.prs_block_products').length>0){
    $('.prs_block_products').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M11.166 19.3335L17.4994 13.0001L11.166 6.66667" stroke="#454545" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M11.166 19.3335L17.4994 13.0001L11.166 6.66667" stroke="#454545" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>',
      responsive: [
        {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        },
      },
        {
          breakpoint: 767,
          settings: "unslick"
        },
      ],
    });
  }
});

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ PRODUCT REANGE SHOWCASE JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ BUTTON CLICK SCROLL JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

document.addEventListener("click", function(e) {
  const link = e.target.closest(".heroslide-button.heroslide-button-scroll");
  if (!link) return;

  e.preventDefault();
  const targetId = link.getAttribute("href");
  if (targetId && targetId.startsWith("#")) {
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",  // smooth scroll
        block: "start"       // top se align
      });
    }
  }
});


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ BUTTON CLICK SCROLL JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ PRODUCT TABING BLOCK JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab-title");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", e => {
      e.preventDefault();

      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Add active class to clicked tab + target content
      tab.classList.add("active");
      const targetId = tab.getAttribute("tab-data-id");
      document.getElementById(targetId).classList.add("active");
    });
  });
});
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ BUTTON CLICK SCROLL JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".shop-look-item").forEach(function (item) {
    // Handle size selection
    const sizeRadios = item.querySelectorAll('input[type="radio"][name="shop_look_first_option_size"]');
    const sizeLabel = item.querySelector('.shop-look-option-size-selected');
    sizeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          sizeLabel.textContent = radio.getAttribute('data-val') || radio.value;
        }
      });
      if (radio.checked) {
        sizeLabel.textContent = radio.getAttribute('data-val') || radio.value;
      }
    });

    // Handle second option (select dropdown)
    const sizeSelect = item.querySelector('select[name="shop_look_second_option_size"]');
    const sizeLabelSecond = item.querySelector('.shop-look-option-size-selected_second');

    if (sizeSelect && sizeLabelSecond) {
      // on change
      sizeSelect.addEventListener('change', function () {
        const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
        const dataVal = selectedOption.getAttribute('data-val') || selectedOption.value;
        sizeLabelSecond.textContent = dataVal;
      });

      // set initial value on page load if something is selected
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && selectedOption.value) {
        sizeLabelSecond.textContent = selectedOption.getAttribute('data-val') || selectedOption.value;
      }
    }
  });
});


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ COLLECTION PAGE PRODUCTS LOAD MORE JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
jQuery(document).ready(function() {
  jQuery('body').addClass('infinite_loading_collcetion');
  var pageLoadId = setInterval(function(){
    if(jQuery('body').hasClass('infinite_loading_collcetion')){
      if(jQuery('.collection-product-loop').find('#custom-collection-pagination').length>0){
        jQuery('.collection-product-loop').find('#custom-collection-pagination').hide();
      }
      let page = 2,
          loading = false,
          totalHeightminus = 140,
          collectionUrl = jQuery("#collection_url").val();

      jQuery(document).on("change",".custom-collection-filters-container .filter-option-input",function(){
        loading = false;
        page=2;
      });

      jQuery(document).on("click",".custom-collection-filters-section .active-filters-clear",function(){
        console.log("clear filterddd");
        loading = false;
        page=2;
      });
      if (jQuery("#load-more-btn-wrapper").length !== 0) {
        function loadMoreProducts() {
          if (loading) return;
          let totalPerPage = jQuery("#per_page_collection").val(),
          totalCollectionProduct = jQuery("#collection_total_products").val(),
          totalPage = Math.ceil(totalCollectionProduct / totalPerPage);
          console.log("totalpage",totalPage,page);
          if (page > totalPage) {
            jQuery("#load-more-btn-wrapper").hide();
            return;
          }

          loading = true;

          // Detect layout type and count (for responsive grids)
          let layoutType, newCount;
          if (window.innerWidth <= 768) {
            layoutType = jQuery(".collection__filter_control")
              .find(".CollectionToolbar__LayoutSwitch")
              .find(".CollectionToolbar__LayoutType.is-active")
              .attr("data-grid-type");
            newCount = jQuery(".collection__filter_control")
              .find(".CollectionToolbar__LayoutSwitch")
              .find(".CollectionToolbar__LayoutType.is-active")
              .attr("data-count");
          } else {
            layoutType = jQuery(".collection__filter_control")
              .find(".CollectionToolbar__LayoutSwitch")
              .eq(1)
              .find(".CollectionToolbar__LayoutType.is-active")
              .attr("data-grid-type");
            newCount = jQuery(".collection__filter_control")
              .find(".CollectionToolbar__LayoutSwitch")
              .eq(1)
              .find(".CollectionToolbar__LayoutType.is-active")
              .attr("data-count");
          }

          // Build URL with pagination and existing filters
          let url = window.location.origin + "/" + collectionUrl + "?page=" + page,
              queryString = window.location.search;

          if (queryString) {
            let rawQueryString = queryString.substring(1);
            var mainurl = window.location.href;
            console.log("mainurl",mainurl);
            url = mainurl + "&page=" + page;
          }

          jQuery("#load-more-btn-wrapper").show();
          console.log("ull",url);
          $.get(url, function(data2) {
            // Find only the product items from the response
            let newProducts = $(data2).find(".product-list--collection .custom-product-card-item");

            if (newProducts.length > 0) {
              // Append products to current grid
              $("#more-products").append(newProducts);

              // Update grid classes
              jQuery(".collection-product-loop")
                .find(".product-list--collection")
                .find(".custom-product-card-item")
                .each(function() {
                  let $item = $(this);
                  let classgridin = $item.hasClass("product_active") ? "product_active" : "product_solout";

                  //$item.attr("class", "Grid__Cell " + classgridin);

                  if (layoutType === "mobile") {
                    $item.addClass(`1/${newCount}--phone`);
                  } else {
                    let newTabletCount = newCount === 2 ? 2 : 3;
                    $item.addClass(`1/${newCount}--lap-and-up`);
                    $item.addClass(`1/${newCount}--desk`);
                    $item.addClass(`1/${newTabletCount}--tablet-and-up`);
                  }
                });

              page++;
              loading = false;

              // Reinitialize any product scripts after load
              if (typeof window.handleMobileBehavior === "function") {
                window.handleMobileBehavior();
              }

              if (totalCollectionProduct < totalPerPage) {
                jQuery("#load-more-btn-wrapper").hide();
                return;
              }

              // Hide button if last page loaded
              if (page > totalPage) {
                jQuery("#load-more-btn-wrapper").hide();
              }
            } else {
              loading = true;
              jQuery("#load-more-btn-wrapper").hide();
            }
          }).fail(function() {
            loading = false;
          });
        }

        // Scroll event for infinite load
        $(window).on("scroll", function() {
          let lastProduct = jQuery("#more-products").find(".custom-product-card-item").last();

          if (lastProduct.length > 0) {
            let loadMoreThreshold = Math.round(lastProduct.offset().top),
                finalHeight = loadMoreThreshold - totalHeightminus;
            //console.log("finalHeight",$(window).scrollTop(),finalHeight,loading);
            if (!loading && $(window).scrollTop() > finalHeight) {
              loadMoreProducts();
            }
          }
        });
      }
      clearInterval(pageLoadId);
    }
  },200);
});
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ COLLECTION PAGE PRODUCTS LOAD MORE JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/*------------------ product page in stoke show order get in outstoke hide get in -- START ------------------ */
document.addEventListener("DOMContentLoaded", function () {

  function checkSoldOut() {
    const checkedInput = document.querySelector('.swatch input[type="radio"]:checked');
    const productForm = document.querySelector('.product_form');

    if (!checkedInput || !productForm) return;

    const swatchDiv = checkedInput.nextElementSibling;

    if (swatchDiv && swatchDiv.classList.contains('soldout')) {
      productForm.classList.add('product_form_soldout');
    } else {
      productForm.classList.remove('product_form_soldout');
    }
  }

  // 🔥 Run after slight delay (important for Shopify)
  setTimeout(checkSoldOut, 100);

  // Run on change
  document.querySelectorAll('.swatch input[type="radio"]').forEach(input => {
    input.addEventListener('change', checkSoldOut);
  });

});
/*------------------ product page in stoke show order get in outstoke hide get in -- END ------------------ */


const el = document.querySelector('.abtest-gallery-original');

function logVH() {
  const vh = window.innerHeight;
  if(el!=null){
    const h = el.getBoundingClientRect().height;
    console.log('Gallery px:', h);
    console.log('Viewport px:', vh);
    console.log('Gallery % of viewport:', ((h / vh) * 100).toFixed(2) + '%');
  }
}

logVH();
window.addEventListener('resize', logVH);

// SAVE SELECTED SIZE IN COOKIE AND AUTO SELECT ON OTHER PRODUCT PAGES START
  document.addEventListener("DOMContentLoaded", function () {

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    function isAvailable(input) {
      const stoks = input.getAttribute('data-stoks');
      if (stoks === null) return true;
      return stoks === "true";
    }

    function updateSelectedSizeText(size) {
      document.querySelectorAll(
        '.swatch--size .selected-swatchval'
      ).forEach(function(el) {
        el.textContent = size;
      });
    }

    function selectFirstAvailableSize() {
      const allInputs = document.querySelectorAll(
        '.swatch--size input[type="radio"]'
      );
      let firstAvailable = null;
      allInputs.forEach(function(input) {
        if (!firstAvailable && isAvailable(input)) {
          firstAvailable = input;
        }
      });
      if (firstAvailable) {
        firstAvailable.click();
        firstAvailable.checked = true;
        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        updateSelectedSizeText(firstAvailable.value);
        console.log('Fallback - First Available Size:', firstAvailable.value);
      }
    }

    function sizeChangeHandler() {
      if (this.checked) {
        const selectedSize = this.value;
        setCookie('selected_size', selectedSize, 30);
        updateSelectedSizeText(selectedSize);
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput) {
          setCookie('selected_variant_id', variantIdInput.value, 30);
        }
        console.log('Saved Size:', selectedSize);
      }
    }

    function bindSizeEvents() {
      document.querySelectorAll(
        '.swatch--size input[type="radio"]'
      ).forEach(function(input) {
        input.removeEventListener('change', sizeChangeHandler);
        input.addEventListener('change', sizeChangeHandler);
      });
    }

    bindSizeEvents();

    // =========================
    const savedSize = getCookie('selected_size');
    console.log("savedSize",savedSize);
    if (savedSize) {

      setTimeout(function() {

        const targetInput = document.querySelector(
          '.swatch--size input[type="radio"][value="' + savedSize + '"]'
        );

        if (targetInput && isAvailable(targetInput)) {

          targetInput.click();
          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
          updateSelectedSizeText(savedSize);

          const savedVariantId = getCookie('selected_variant_id');
          const variantIdInput = document.querySelector('input[name="id"]');

          if (savedVariantId && variantIdInput) {
            variantIdInput.value = savedVariantId;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          console.log('Auto Selected Size:', savedSize);

        } else {

          // saved size unavailable - first available select
          console.log('Saved size unavailable:', savedSize, '- selecting first available');
          selectFirstAvailableSize();

        }

      }, 1500);

    }
  });

  // ========================= QUICK SHOP SELECT CLICK =========================
  document.querySelectorAll('.quick-shop-select').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const selectedSizeQuick = this.value;
      const variantIdInputQuick = this.previousElementSibling;

      if (selectedSizeQuick) {
        setCookie('selected_size', selectedSizeQuick, 30);
        console.log('Quick Shop - Saved Size:', selectedSizeQuick);
      }

      if (variantIdInputQuick && variantIdInputQuick.name === 'id') {
        setCookie('selected_variant_id', variantIdInputQuick.value, 30);
        console.log('Quick Shop - Saved Variant ID:', variantIdInputQuick.value);
      }
    });
  });
// SAVE SELECTED SIZE IN COOKIE AND AUTO SELECT ON OTHER PRODUCT PAGES END




// NEW HOME PAGE SECTION'S JS START 

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SHOP THE LOOK JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  $(document).ready(function () {
    $('.look-cards').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M11.166 19.3335L17.4994 13.0001L11.166 6.66667" stroke="#454545" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M11.166 19.3335L17.4994 13.0001L11.166 6.66667" stroke="#454545" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
          // settings: "unslick"
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SHOP THE LOOK JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SOCIAL-MEDIA-SCROLL JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

  $(document).ready(function () {
      $('.social-media-scrollbar').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: false,
        infinite: true,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SOCIAL-MEDIA-SCROLL JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  $(document).ready(function () {
    $('.tailored-athlete-testimonials-v-one .tat-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  $(document).ready(function () {
    $('.tailored-athlete-testimonials-v-two .tat-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  $(document).ready(function () {
    $('.fullbanner-tat-section .tat-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ HOME TESTIMONIAL SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TAB FEATURE PRODUCT SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  jQuery(document).ready(function ($) {
    $('.collection-product-tab').hide();
    $('ul.collection-tab li:first').addClass('active');
    $('.collection-product-tab:first').show();
    $('ul.collection-tab li').on('click', function (e) {
      e.preventDefault();
      if($(".pro-collection-gallery").hasClass("slick-initialized")){
        $(".pro-collection-gallery").slick('refresh');
      }
      
      $('ul.collection-tab li').removeClass('active');
      
      $(this).addClass('active');
      let tabId = $(this).data('id');
      $('.collection-product-tab').hide();
      $('#' + tabId).show();
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TAB FEATURE PRODUCT SLIDER JS--START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Trustpilot Reviews SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  jQuery(document).ready(function ($) {
    
    $('.trustpilot-slide').slick({
      dots: false,
      arrow: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 6L9 12L15 18" stroke="#454545" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#454545" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Trustpilot Reviews SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Product Slider SLIDER JS--START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// document.querySelectorAll('.products-slider_swiper').forEach((slider) => {
//   const section = slider.closest('.featured-collection-slider');
//   if (!section) return;
//   const swiper = new Swiper(slider, {
//     spaceBetween: 16,
//     grabCursor: true,
//     slidesPerView: 4,
//     freeMode: false,
//     slidesPerGroup: 1,
//     watchOverflow: true,
//     pagination: {
//       el: section.querySelector('.swiper-pagination'),
//       type: 'progressbar',
//     },
//     breakpoints: {
//       0: { slidesPerView: 2 },
//       750: { slidesPerView: 3 },
//       1024: { slidesPerView: 4 },
//     },
//     on: {
//       init: function () {
//         const prevBtn = section.querySelector('.slider-prev-arrow');
//         const nextBtn = section.querySelector('.slider-prev-next');

//         if (prevBtn && nextBtn) {
//           prevBtn.addEventListener('click', () => this.slidePrev());
//           nextBtn.addEventListener('click', () => this.slideNext());
//         }
//       }
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.js-product-slider .products-slider_swiper', {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: false,
    navigation: {
      nextEl: '.featured-collection-slider .slider-prev-next',
      prevEl: '.featured-collection-slider .slider-prev-arrow',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    breakpoints: {
      300: { 
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767: { 
        slidesPerView: 3 
      },
      1024: { 
        slidesPerView: 4 
      },
      1441: { 
        slidesPerView: 5
      },
    },
  });
});

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Product Slider SLIDER JS--END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// NEW HOME PAGE SECTION'S JS END

/* kiwi sizing start */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.kiwi-inject-class');
  if (!trigger) return;
  e.preventDefault();

  var scope = trigger.parentElement;
  var kiwiBtn = null;
  while (scope && !kiwiBtn) {
    kiwiBtn = scope.querySelector('.ks-chart-modal-button');
    scope = scope.parentElement;
  }
  if (!kiwiBtn) {
    kiwiBtn = document.querySelector('.ks-chart-modal-button');
  }
  if (kiwiBtn) {
    kiwiBtn.click();
  }
});
/* kiwi sizing end */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Lead Image Variation -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// lead image variation - start 
// custom.lead_image_variation: when html.ta-lead-image is set (snippets/ab-lead-image.liquid), on the product page this puts the
// lead image first in every gallery and shifts the original images back by one.
// Collection page cards are handled in CSS (see custom.css).
(function () {
  function setImg(img, data, isThumb) {
    if (!img) return;
    img.classList.remove('lazyloaded', 'lazyloading');
    // Keep the cloned data-image-id (first image's media id): on load the variant selector
    // (sections.js selectCallback) looks up the first [data-image-id] match, which is now the lead slide.
    img.alt = data.alt;
    if (isThumb) {
      img.src = data.thumb;
      img.removeAttribute('srcset');
      return;
    }
    if (img.hasAttribute('data-src') || img.classList.contains('lazyload')) {
      img.classList.add('lazyload');
      img.setAttribute('data-src', data.src);
      img.setAttribute('data-srcset', data.srcset);
      img.setAttribute('srcset', data.srcset);
      img.src = data.src;
    } else {
      img.src = data.master;
      img.removeAttribute('srcset');
    }
    if (img.hasAttribute('data-zoom-src')) img.setAttribute('data-zoom-src', data.zoom);
    if (data.width && data.height) {
      img.setAttribute('width', data.width);
      img.setAttribute('height', data.height);
      if (img.hasAttribute('data-aspectratio')) img.setAttribute('data-aspectratio', data.width + '/' + data.height);
    }
  }

  function makeLeadCell(firstCell, data, isThumb) {
    const cell = firstCell.cloneNode(true);
    cell.classList.remove('is-selected', 'is-nav-selected');
    cell.classList.add('ta-lead-cell');
    cell.removeAttribute('style');
    cell.removeAttribute('aria-hidden');
    cell.setAttribute('data-title', data.alt);
    cell.setAttribute('data-media-type', 'image');
    cell.querySelectorAll('.new__img').forEach((el) => el.remove());
    cell.querySelectorAll('a.lightbox').forEach((a) => a.setAttribute('href', data.zoom));
    cell.querySelectorAll('.pgallery---modalinfo').forEach((el) => (el.textContent = data.alt));
    const imgs = isThumb ? cell.querySelectorAll('img') : cell.querySelectorAll('img.product-gallery__image');
    imgs.forEach((img) => {
      setImg(img, data, isThumb);
      if (!isThumb) img.setAttribute('data-index', 0);
    });
    return cell;
  }

  function prependCell(gallery, cell) {
    const flkty = window.Flickity && window.Flickity.data(gallery);
    if (flkty) {
      flkty.prepend(cell);
      flkty.select(0, false, true);
    } else {
      const firstCell = gallery.querySelector('.gallery-cell');
      firstCell.parentNode.insertBefore(cell, firstCell);
    }
  }

  function applyLeadImage() {
    if (!document.documentElement.classList.contains('ta-lead-image')) return;

    document.querySelectorAll('.ta-lead-image-data:not([data-applied])').forEach((dataEl) => {
      dataEl.setAttribute('data-applied', 'true');
      const data = Object.assign({}, dataEl.dataset);
      const root = dataEl.closest('.product-page-gallery') || dataEl.parentElement.parentElement;

      // Desktop grid layout (product-full-media-product template)
      root.querySelectorAll('.data-for-desktop').forEach((grid) => {
        const first = grid.querySelector('.product-image');
        if (!first) return;
        const tile = first.cloneNode(true);
        tile.querySelectorAll('img').forEach((img) => setImg(img, data, false));
        grid.insertBefore(tile, first);
      });

      // Main sliders (incl. the hidden .productstate slider that mirrors slide indexes)
      root.querySelectorAll('.js-product-gallery').forEach((gallery) => {
        const cells = gallery.querySelectorAll('.gallery-cell');
        if (!cells.length) return;
        const firstImageCell = gallery.querySelector('.gallery-cell.gc-image') || cells[0];
        // Shift the indexes used for variant image switching
        gallery.querySelectorAll('img[data-index]').forEach((img) => {
          const index = parseInt(img.getAttribute('data-index'), 10) + 1;
          img.setAttribute('data-index', index);
          if (window.jQuery) jQuery(img).data('index', index);
        });
        prependCell(gallery, makeLeadCell(firstImageCell, data, false));
      });

      // Thumbnails
      root.querySelectorAll('.product_gallery_nav').forEach((nav) => {
        const firstThumb = nav.querySelector('.product-gallery__thumbnail');
        if (!firstThumb) return;
        const thumb = makeLeadCell(firstThumb, data, true);
        thumb.addEventListener('click', () => {
          root.querySelectorAll('.js-product-gallery').forEach((gallery) => {
            const flkty = window.Flickity && window.Flickity.data(gallery);
            if (flkty) flkty.select(0);
          });
        });
        prependCell(nav, thumb);
      });
    });
  }

  applyLeadImage();
  document.addEventListener('DOMContentLoaded', applyLeadImage);
  new MutationObserver(applyLeadImage).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
// lead image variation - end

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TA - Lead Image Variation -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */